module.exports = __webpack_public_path__ + "img/gemnote-no-image_updated.9c467704.png";